import { TeamMetricsApiClient, teamMetricsApiRef } from './teamMetricsApi';
import { configApiRef, createApiFactory, createPlugin, oktaAuthApiRef } from '@backstage/core-plugin-api';

export const teamMetricsApiPlugin = createPlugin({
  id: 'team-metrics-api',
  apis: [
    createApiFactory({
      api: teamMetricsApiRef,
      deps: { configApi: configApiRef, oktaAuthApi: oktaAuthApiRef },
      factory: ({ configApi, oktaAuthApi }) => new TeamMetricsApiClient(configApi, oktaAuthApi),
    }),
  ],
});
